import { z } from "zod";

export enum EMyVPRogrammingType {
  DEFAULT = "DEFAULT",
  USER = "USER",
  QUICK = "QUICK",
  MANUAL = "MANUAL",
  UNKNOWN = "UNKNOWN",
  ERROR = "ERROR",
}

export const myvProgrammingTypeDtoSchema = z.nativeEnum(EMyVPRogrammingType);

export type TMyvProgrammingTypeDto = z.infer<typeof myvProgrammingTypeDtoSchema>;
